import en from './en.json';
import ar from './ar.json';

const menuMessages = {
    en, ar
}

export default menuMessages;